module.exports = "/_next/static/images/be03865c88e3e5d11e8b5ea044d8ccaa-phone-and-card@md-2x.jpg";